export const loginRoutes = {
  name: 'login',
  path: '/login',
  component: () => import('pages/Login/index.vue'),
  meta: {
    title: 'Login',
  },
}
